import React from 'react';
import { compose } from '@/utils/story-composer';
import Carousel from '@/components/elements/carousel';
import { formatUrl } from '@/utils/url';
import BlogPostTile from '@/components/layout/blog/post-tile';
import { getTranslatableSlug } from '@/utils/translatable-slug';

function FeaturedBlogs({ posts = [], pageContext, heading, buttons }) {
	const BlogTiles = posts.map(post => (
		<BlogPostTile key={post._uid} post={post} pageContext={pageContext} isCarouselItem={true} />
	));

	return <Carousel content={BlogTiles} heading={heading} buttons={buttons} slidesToShow={3} />;
}

export default FeaturedBlogs;

compose('featured-blogs', FeaturedBlogs, {
	children: ['content'],
	mapBlokToProps: (props, pageContext) => ({
		...props,
		posts: pageContext.featuredBlogs?.map(blog => {
			const translatedSlug = getTranslatableSlug(blog, blog.lang);
			const blogTitle = translatedSlug?.name || blog.name;

			return {
				_uid: blog.uuid,
				full_slug: formatUrl(blog.full_slug),
				published_at: blog.published_at,
				first_published_at: blog.first_published_at,
				name: blogTitle,
				lang: blog.lang,
				content: blog.content,
				images: blog.images,
			};
		}),
	}),
});
